import React from 'react';
import type { VisualizationMeta } from '../../../visualization-schema';

import { useTranslation } from 'react-i18next';

interface TableHeaderProps {
  visualizationMeta?: VisualizationMeta;
  totalResults: number;
}

export const TableHeader: React.FC<TableHeaderProps> = ({
  visualizationMeta,
  totalResults,
}) => {
  const { t } = useTranslation('pleri/chat');
  const hasHeaderContent =
    visualizationMeta?.options?.title ||
    visualizationMeta?.options?.description;

  return (
    <>
      {hasHeaderContent && (
        <div className="border-b border-gray-200 px-6 py-4 dark:border-gray-700">
          {visualizationMeta.options?.title && (
            <h3 className="text-lg font-medium text-gray-900 dark:text-gray-100">
              {visualizationMeta.options.title}
            </h3>
          )}
          {visualizationMeta.options?.description && (
            <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
              {visualizationMeta.options.description}
            </p>
          )}
        </div>
      )}
      {totalResults > 0 && (
        <div className="px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="text-sm font-medium text-gray-700 dark:text-gray-300">
              {t('results', { totalResults })}
            </div>
          </div>
        </div>
      )}
    </>
  );
};
